export default {
  plural: 'Twin-детали',
  createButton: 'Создать деталь',
  createTitle: 'Создать деталь',
  editTitle: 'Редактировать деталь',
  deleteTitle: 'Удалить деталь',
  deleteWarning: 'Вы уверены, что хотите удалить эту деталь?',
  company: 'Компания'
};
